import { createAsyncThunk } from "@reduxjs/toolkit";

import api from "../../../utils/api";
import { RootState } from "../../rootReducer";
import axios from "axios";
import axiosInstance from "../../../utils/axiosConfig";

// Busqueda de personas según criterio para notificación masiva
export const findPeople = createAsyncThunk(
  "massNotifications/findPeople",
  async (arg, { rejectWithValue, getState }) => {
    try {
      const state = getState() as RootState;
      const documentsTypes = state.massNotification.selectedDocumentTypes;
      const userRoles = state.massiveDocumentCreate.userRole;
      const createdAtFilter = state.massNotification.createdAtFilter;
      const idsDocumentsTypes = documentsTypes.map((documentType) => documentType.id);
      const { data } = await axiosInstance.post(`${api.baseURL}document/users-pending-signature`, {
        idDocumentType: idsDocumentsTypes,
        organization: state.userAuthentication.user?.sourceOrganization,
        startDate: createdAtFilter?.from ? createdAtFilter?.from : null,
        endDate: createdAtFilter?.to ? createdAtFilter?.to : null,
      });

      const peopleList: any = [];
      data.map((user: any) => {
        if (userRoles.find((userRole) => userRole.user?.id === user)) {
          peopleList.push({
            id: user,
            name: userRoles.find((userRole) => userRole.user?.id === user)?.user.name,
            role: userRoles.find((userRole) => userRole.user?.id === user)?.role?.name,
            location: userRoles.find((userRole) => userRole.user?.id === user)?.location,
            code: userRoles.find((userRole) => userRole.user?.id === user)?.location?.code,
          });
        }
      });

      const peopleListSorted = [...peopleList].sort((a, b) => {
        if (a.name && b.name && a.name < b.name) {
          return -1;
        }
        if (a.name && b.name && a.name > b.name) {
          return 1;
        }
        return 0;
      });

      return peopleListSorted;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
